module.exports = __webpack_public_path__ + "static/15-7e57b1ebdfdaef27c413911ce66b1697.png";